export default __webpack_public_path__ + "static/media/AlarmSetInput.6efcad69.png";